<template>
    <div id="homepage">
        <page-header></page-header>
        <list-services></list-services>
        <counselors></counselors>
        <network-moranow></network-moranow>        
        <!-- <how-it-work></how-it-work>         -->
        <!-- <benefit></benefit> -->
        <!-- <list-university></list-university> -->        
        <customer-mora></customer-mora>
        <!-- <philosophy-mora></philosophy-mora> -->
    </div>
</template>
<script>
// import HowItWork from "./components/HomePage/HowItWork";
// import Benefit from "./components/HomePage/Benefit";
// import ListUniversity from "./components/HomePage/ListUniversity";
// import PhilosophyMora from "./components/HomePage/PhilosophyMora.vue"
import PageHeader from "./components/HomePage/PageHeader.vue";
import CustomerMora from "./components/HomePage/CustomerMora";
import Counselors from "./components/HomePage/Counselors";
import ListServices from "./components/HomePage/ListServices";
import NetworkMoranow from "./components/HomePage/NetworkMoranow";
import {mapActions} from "vuex";
export default {
  name: "components",
  components: {
    // PhilosophyMora,
    PageHeader,    
    CustomerMora,
    Counselors,
    ListServices,
    NetworkMoranow,
    // HowItWork,
    // Benefit,
    // ListUniversity,
  },
  created: function(){    
    this.$store.dispatch('vuex_homepage/fetch_data')  
  }
};
</script>
<style lang="scss">
@import "./components/Responsive/query.scss";
#homepage{
  @include for-desktop-up{
    .container{ 
      max-width: 1200px; 
    }
  }
  @include for-big-desktop-up{
    .container{ 
      max-width: 1500px; 
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/HomePage.vue